// extracted by mini-css-extract-plugin
export default {"container":"MetricsContent_container__Ame21"};